module.exports = __webpack_public_path__ + "static/media/editor.f9c228c4.svg";